import api from '../..'
import { IEnrolModel } from 'models/enrol.model'

const updateApplication = (enrol: IEnrolModel) => {
  const { id } = enrol
  return api.put(`administration/applications/${id}`, { enrol })
}

export default updateApplication
